var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 311,
    viewBox: "0 0 414 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.643 0.37793C133.071 0.37793 127.564 17.5004 118.286 52.1279H295.714C286.09 16.2096 279.926 0.37793 251.357 0.37793H162.643ZM88.7143 74.3065C29.5714 74.3065 0 103.878 0 163.021V222.164C0 281.306 29.5714 310.878 88.7143 310.878H325.286C384.429 310.878 414 281.306 414 222.164V163.021C414 103.878 384.429 74.3065 325.286 74.3065H88.7143ZM73.9286 103.878C82.0945 103.878 88.7143 110.498 88.7143 118.664C88.7143 126.83 82.0945 133.449 73.9286 133.449C65.7626 133.449 59.1429 126.83 59.1429 118.664C59.1429 110.498 65.7626 103.878 73.9286 103.878ZM207 103.878C255.475 103.878 295.714 141.2 295.714 192.592C295.714 243.107 256.495 281.306 207 281.306C158.525 281.306 118.286 242.23 118.286 192.592C118.286 140.323 157.648 103.878 207 103.878ZM207 133.449C173.043 133.449 147.857 156.881 147.857 192.592C147.857 229.181 172.166 251.735 207 251.735C242.711 251.735 266.143 228.303 266.143 192.592C266.143 157.758 241.834 133.449 207 133.449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoVideo);
export default __webpack_public_path__ + "static/media/photo_video.6598fa2487371b1cfa38e4540c368e7e.svg";
export { ForwardRef as ReactComponent };